export default __webpack_public_path__ + "static/media/140.2ea2885a.gif";